// SPDX-License-Identifier: AGPL-3.0-or-later

export function shouldShowAppZoomLevel(): boolean {
	// KONVO: zoom works on web too (rem-scaled via --custom-zoom), so the
	// setting is always available; upstream shows it only in the desktop app.
	return true;
}
